module.exports = __webpack_public_path__ + "img/old_Shanghai.0508bf0e.png";